export default __webpack_public_path__ + "static/media/news1.e5a34665.webp";